import { render, staticRenderFns } from "./TruckHistoryTab.vue?vue&type=template&id=3a3d0021&scoped=true&"
import script from "./TruckHistoryTab.vue?vue&type=script&lang=js&"
export * from "./TruckHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TruckHistoryTab.vue?vue&type=style&index=1&id=3a3d0021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d0021",
  null
  
)

export default component.exports